import React from 'react';
import { Route } from 'react-router-dom';
import { lazyWithRetry } from './lazyWithRetry';
import PartnerServiceGate from '../components/Partner/PartnerServiceGate';

const PartnerLayout = lazyWithRetry(() => import("../layout/PartnerLayout"));
const PartnerHome = lazyWithRetry(() => import("../pages/PartnerHome"));
const PartnerEvents = lazyWithRetry(() => import("../pages/PartnerEvents"));
const PartnerEventDetail = lazyWithRetry(() => import("../pages/PartnerEventDetail"));
const PartnerEventAnalytics = lazyWithRetry(() => import("../pages/PartnerEventAnalytics"));
const PartnerAmbassadors = lazyWithRetry(() => import("../pages/PartnerAmbassadors"));
const PartnerMarketing = lazyWithRetry(() => import("../pages/PartnerMarketing"));
const PartnerUGC = lazyWithRetry(() => import("../pages/PartnerUGC"));
const PartnerSubmitEvent = lazyWithRetry(() => import("../pages/PartnerSubmitEvent"));
const PartnerSettings = lazyWithRetry(() => import("../pages/PartnerSettings"));
const PartnerJobs = lazyWithRetry(() => import("../pages/jobs/PartnerJobs"));
const JobApplications = lazyWithRetry(() => import("../pages/jobs/JobApplications"));
const PartnerRestaurantProfile = lazyWithRetry(() => import("../pages/PartnerRestaurantProfile"));
const PartnerRestaurantMenu = lazyWithRetry(() => import("../pages/PartnerRestaurantMenu"));
const PartnerRestaurantOffers = lazyWithRetry(() => import("../pages/PartnerRestaurantOffers"));
const PartnerRestaurantBookings = lazyWithRetry(() => import("../pages/PartnerRestaurantBookings"));
const PartnerSubscription = lazyWithRetry(() => import("../pages/PartnerSubscription"));

function Gated({ serviceKey, featureName, children }) {
  return (
    <PartnerServiceGate serviceKey={serviceKey} featureName={featureName}>
      {children}
    </PartnerServiceGate>
  );
}

export const PartnerRoutes = () => (
  <Route key="partner-dashboard" path="/partner-dashboard" element={<PartnerLayout />}>
    <Route index element={<PartnerHome />} />
    <Route path="events" element={<Gated serviceKey="events" featureName="Events"><PartnerEvents /></Gated>} />
    <Route path="events/:id" element={<Gated serviceKey="events" featureName="Events"><PartnerEventDetail /></Gated>} />
    <Route path="events/:eventId/analytics" element={<Gated serviceKey="events" featureName="Events"><PartnerEventAnalytics /></Gated>} />
    <Route path="ambassadors" element={<Gated serviceKey="lifestyle" featureName="Ambassadors"><PartnerAmbassadors /></Gated>} />
    <Route path="marketing" element={<Gated serviceKey="lifestyle" featureName="Marketing"><PartnerMarketing /></Gated>} />
    <Route path="ugc" element={<Gated serviceKey="ugc" featureName="UGC Creators"><PartnerUGC /></Gated>} />
    <Route path="submit-event" element={<Gated serviceKey="events" featureName="Events"><PartnerSubmitEvent /></Gated>} />
    <Route path="settings" element={<PartnerSettings />} />
    <Route path="subscription" element={<PartnerSubscription />} />
    <Route path="jobs" element={<Gated serviceKey="jobs" featureName="Job Board"><PartnerJobs /></Gated>} />
    <Route path="jobs/:id/applications" element={<Gated serviceKey="jobs" featureName="Job Board"><JobApplications /></Gated>} />
    <Route path="restaurant" element={<Gated serviceKey="restaurants" featureName="Restaurants"><PartnerRestaurantProfile /></Gated>} />
    <Route path="restaurant/menu" element={<Gated serviceKey="restaurants" featureName="Restaurants"><PartnerRestaurantMenu /></Gated>} />
    <Route path="restaurant/offers" element={<Gated serviceKey="restaurants" featureName="Restaurants"><PartnerRestaurantOffers /></Gated>} />
    <Route path="restaurant/bookings" element={<Gated serviceKey="restaurants" featureName="Restaurants"><PartnerRestaurantBookings /></Gated>} />
  </Route>
);